import './LanguagePanel.scss';
import React, {useContext} from 'react';
import {Context} from "../../App";
import i18next from "i18next";

function LanguagePanel() {
  const context = useContext(Context);
  const language = context.language.get;
  const iconBaseURL = process.env.PUBLIC_URL + './assets/flags/';
  const availableLanguages = ['eng', 'arm', 'fre'];
  let className;

  const changeLanguage = lang => {
    context.language.set(lang);
    i18next.changeLanguage(lang, error => error ? console.log('i18n error: ', error) : null).then();
  }

  return <div className='language-panel'>
    {
      availableLanguages.map((lang, index) => {
        className = lang === language ? 'lang-icon active' : 'lang-icon';
        return <img className={className} src={iconBaseURL + lang + '.svg'} alt='' key={index}
                    onClick={() => context.language.set(lang)}/>
      })
    }
  </div>
}

export default LanguagePanel;